import { http } from '@pendo/http';

export function createNode (journeyId, node) {
    return http.post(`/api/s/_SID_/journey/${journeyId}/node`, node).then((res) => res.data);
}

export function updateNode (journeyId, updatedNode) {
    return http.put(`/api/s/_SID_/journey/${journeyId}/node/${updatedNode.id}`, updatedNode).then((res) => res.data);
}

export function deleteNode (journeyId, nodeId) {
    return http.delete(`/api/s/_SID_/journey/${journeyId}/node/${nodeId}`).then((res) => res.data);
}

export function createEdge (journeyId, edge) {
    return http.post(`/api/s/_SID_/journey/${journeyId}/edge`, edge).then((res) => res.data);
}

export function updateEdge (journeyId, updatedEdge) {
    return http.put(`/api/s/_SID_/journey/${journeyId}/edge/${updatedEdge.id}`, updatedEdge).then((res) => res.data);
}

export function deleteEdge (journeyId, edgeId) {
    return http.delete(`/api/s/_SID_/journey/${journeyId}/edge/${edgeId}`).then((res) => res.data);
}
